import { compose } from '@bem-react/core';
import {
    IPopupProps as IPopupDesktopProps,
    IPopupTargetAnchorProps,
    withViewPlatform,
} from '@yandex-int/edu-components/Popup/desktop';
import { Popup as PopupBase } from '@yandex-lego/components/Popup/desktop/bundle';
import { withZIndex } from '@yandex-lego/components/withZIndex';
import type { ComponentType } from 'react';

export interface PopupProps extends IPopupDesktopProps, IPopupTargetAnchorProps {
    view?: 'platform' | 'default';
}

export const EduPopup = compose(withViewPlatform, withZIndex)(PopupBase) as ComponentType<PopupProps>;
